import { createActionTypes } from '../../../../util/createActionsHelpers';

export const GET_FEED_ARTICLES = createActionTypes('GET_FEED_ARTICLES');
